export const environment = {
  production: true,
  environment : 'PROD',
  baseURL : 'https://accounts.zuperpro.com/api',
  serviceURL: 'https://app.zuperpro.com/service',
  fileExplorerURL : 'https://app.zuperpro.com/service/file_explorer',
  lmsURL : 'https://app.zuperpro.com/service/lms',
  wssURL : 'https://app.zuperpro.com:8443',
  webhookURL: 'https://app.zuperpro.com/service/notifications',
  appStoreURL : 'https://apps.zuperpro.com/',
  dcURL: 'https://accounts.zuperpro.com/api',
  hereKey: {
    appID  : 'pNa92bBLuEfcxTw6DAze',
    appCode: '_6yStMUJind787_5ppXR9A',
    useHTTPS: true
  },
  hereMapKey: '-kwvjoT20WuvA_C3AGxDAOj9fMSPoM-DcyzhX0T6SMI',
  googleMapKey: 'AIzaSyB_LDXpb58SXx4I4dp0UVhKb1mJGqkDn8w',
  settings: 'https://app.zuperpro.com/settings',
  settingsBaseUrl: 'https://app.zuperpro.com',
  callerUrl: 'https://connect-widget.zuperpro.com/caller',
  firebase: {
    apiKey: 'AIzaSyACnfsoGWSBEw2AKyZaN8qIXDPEUeURZOc',
    authDomain: 'zuperv2-8e691.firebaseapp.com',
    databaseURL: 'https://zuperv2-8e691.firebaseio.com',
    projectId: 'zuperv2-8e691',
    storageBucket: 'zuperv2-8e691.appspot.com',
    messagingSenderId: '613293321746',
    appId: '1:613293321746:web:7095c6012350c2826fb2cb',
    measurementId: 'G-00YDN82TGB'
  },
  lightGalleryKey: '1A23C39D-57B2-4A1B-8793-63F527CB8DA4',
  mixpanel: '8bcc44d1d1f76a3e2cd3d616c80737cd',
  workflowBuilder: {
    baseURL: 'https://staging-workflow.zuperpro.com',
    socketURL: 'https://staging-workflow.zuperpro.com',
    dcBaseURL : 'https://staging-dc.zuperpro.com',
    gateKeeperURL: 'https://staging-workflow.zuperpro.com/api/gatekeeper'
  },
  integratedDialers: {
    'aircall': 'aircall',
    'ringcentral': 'ringcentral'
  }
};
